<div class="container py-4">
  <div class="row">
    <div class="col-lg-10 offset-lg-1">
      <div class="card shadow-sm">
        <div class="card-body">
          <h5 class="card-title mb-3">Rezept-Editor mit intelligenten Zutaten-Pills</h5>
          <app-recipe-editor-v2
            serializedText='<t k="unit">20g</t> <t k="ingredient">Hefe</t> und auch etwas <t k="ingredient">Butter</t>.'
            [autocompleteIngredients]="ingredientNames"
            [emitOnBlur]="true"
            [debug]="true"
            (serializedTextChange)="onSerializedV2Change($event)"
          ></app-recipe-editor-v2>

          <div class="card shadow-sm mt-3">
            <div class="card-body">
              <h6 class="card-title mb-2">V2 serialized output</h6>
              <pre class="bg-light p-3 rounded border" style="white-space: pre-wrap; font-family: monospace; font-size: 14px;">{{ serializedFromV2 }}</pre>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm">
        <div class="card-body">
          <h5 class="card-title mb-3">Rezept-Editor mit intelligenten Zutaten-Pills</h5>
          <app-recipe-editor-v2
            serializedText=''
          ></app-recipe-editor-v2>
        </div>
      </div>
    </div>
  </div>
</div>


<!--
      <div class="card shadow-sm mt-4">
        <div class="card-body">
          <h5 class="card-title mb-3">Rezept-Editor mit intelligenten Zutaten-Pills</h5>
          <p class="text-muted small mb-3">
            <strong>Anleitung:</strong> Tippen Sie eine Menge + Einheit (z.B. "300g" oder "20") und drücken Sie <kbd>Leertaste</kbd>.
            Das System fügt automatisch unsichtbare Unicode-Marker ein und zeigt farbige Pills.
            <br>
            Tippen Sie dann die Zutat innerhalb des grünen Pills.
          </p>

          <app-recipe-pill-editor
            [initialText]="initialRecipeText"
            (textChange)="onTextChange($event)"
            (textChangeReadable)="onTextChangeReadable($event)"
          ></app-recipe-pill-editor>
        </div>
      </div>

      <div class="card shadow-sm mt-4">
        <div class="card-body">
          <h6 class="card-title">Aktueller Plain Text <span class="badge bg-info">{{ recipeText.length }} Zeichen</span></h6>
          <pre class="bg-light p-3 rounded border" style="white-space: pre-wrap; font-family: monospace; font-size: 14px;">{{ recipeText }}</pre>
          <div class="alert alert-info mt-2 small">
            <strong>Hinweis:</strong> Der Text enthält unsichtbare Unicode-Delimiter für die Markierung von Zutaten.
          </div>
        </div>
      </div>

      <div class="card shadow-sm mt-4">
        <div class="card-body">
          <h6 class="card-title">Readable Markers <span class="badge bg-warning">Nur für Debug</span></h6>
          <pre class="bg-warning bg-opacity-10 p-3 rounded border border-warning" style="white-space: pre-wrap; font-family: monospace; font-size: 14px;">{{ recipeTextReadable || initialRecipeText }}</pre>
          <div class="alert alert-warning mt-2 small">
            <strong>Debug:</strong> Unicode-Delimiter wurden durch lesbare Tags ersetzt: &lt;unit_start&gt;, &lt;unit_end&gt;, &lt;ingredient_start&gt;, &lt;ingredient_end&gt;
            <br>
            <strong>Hinweis:</strong> Die Zutatenerkennung erfolgt jetzt im Backend.
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
